/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyServiceQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyServiceQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyServiceQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyServiceQueryOperator>): PolicyServiceQueryOperator {
        let obj = Object.assign(new PolicyServiceQueryOperator(), model);
        PolicyServiceQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyServiceQueryOperator>): PolicyServiceQueryOperator {
        if (!model) return null;
        return PolicyServiceQueryOperator.newInstance(<PolicyServiceQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyServiceQueryOperator) {
        if (!obj) return;

        models.PolicyServiceQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyServiceQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyServiceQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud services to include
     */
    services: Array<string>;

}
